import Unit from '@leverege/unit';
class UnitAttributeValueSuggestor {
  constructor(type, opts = {}) {
    this.attribute = opts.attribute;
    this.unitTypes = this.attribute ? Unit.getUnitsOfType(this.attribute.valueType).map(u => ({
      symbol: u.symbol,
      displaySymbol: u.displaySymbol
    })) : [];
  }
  async suggest(value) {
    return [value, ...this.unitTypes.map(unit => ({
      value: `${value} ${unit.symbol}`,
      name: `${value}${unit.displaySymbol}`
    }))];
  }
}
export default {
  install(molten, blueprint) {
    const types = Unit.getUnitTypes();
    types.forEach(type => {
      molten.addPlugin('AttributeValueSuggestor', {
        id: `molten.AttributeValueSuggestor.${blueprint.type}.${type}`,
        type: `${blueprint.type}.${type}`,
        suggestor: UnitAttributeValueSuggestor
      });
    });
  }
};